import React from "react";

export default function ProductCatalogColumnPicker({
  columns,
  visibleColumnKeys,
  onChange,
}) {
  const optionalKeys = columns
    .map(({ key }) => key)
    .filter((key) => key !== "Model");
  const allOptionalColumnsVisible = optionalKeys.every((key) =>
    visibleColumnKeys.includes(key),
  );

  return (
    <details className="group relative">
      <summary className="flex cursor-pointer list-none items-center gap-2 rounded border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-800 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-200 group-open:border-blue-600 group-open:bg-blue-50 group-open:text-blue-900 group-open:ring-2 group-open:ring-blue-200">
        <span>Columns</span>
        <svg
          aria-hidden="true"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          className="h-4 w-4 transition-transform group-open:rotate-180"
        >
          <path
            d="m5 7.5 5 5 5-5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </summary>
      <div className="absolute right-0 z-30 mt-1 max-h-80 w-56 overflow-y-auto rounded-md border border-gray-200 bg-white p-2 shadow-lg">
        {columns.map(({ key, label }) => (
          <label
            key={key}
            className="flex cursor-pointer items-center gap-2 rounded px-2 py-1.5 text-sm text-gray-800 hover:bg-gray-50"
          >
            <input
              type="checkbox"
              checked={visibleColumnKeys.includes(key)}
              disabled={key === "Model"}
              onChange={(event) =>
                onChange(
                  event.target.checked
                    ? [...visibleColumnKeys, key]
                    : visibleColumnKeys.filter(
                        (visibleKey) => visibleKey !== key,
                      ),
                )
              }
              className="rounded border-gray-300 text-blue-700 focus:ring-blue-600"
            />
            {label}
          </label>
        ))}
        <div role="separator" className="my-2 border-t border-gray-200" />
        <button
          type="button"
          onClick={() =>
            onChange(
              allOptionalColumnsVisible
                ? ["Model"]
                : ["Model", ...optionalKeys],
            )
          }
          className="w-full rounded px-2 py-1.5 text-left text-sm font-medium text-blue-800 hover:bg-blue-50"
        >
          {allOptionalColumnsVisible
            ? "Hide all columns"
            : "Display all columns"}
        </button>
      </div>
    </details>
  );
}
